import { render, staticRenderFns } from "./page016.vue?vue&type=template&id=5abe3498&scoped=true&"
import script from "./page016.vue?vue&type=script&lang=js&"
export * from "./page016.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe3498",
  null
  
)

export default component.exports